import React, { useEffect, useState } from 'react';
import TableNew from 'RooV1.12/TableNew';
import request from '@/utils/request';

interface DistributeRecordProps {
    distributeId: string;
    providerId: number;
}

const DistributeRecord: React.FC<DistributeRecordProps> = ({ distributeId, providerId }) => {
    const [data, setData] = useState([]);
    const [loading, setLoading] = useState(false);

    const fetchRecords = async () => {
        setLoading(true);
        try {
            const response = await request.get('/api/thirdpartnar/record/get', {
                distribute_id: distributeId,
                provider_id: providerId,
            });
            const records = response.data ? response.data : [];
            setData(records);
        } catch (error) {
            console.error('API 请求失败:', error.response || error.message);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchRecords();
    }, [distributeId, providerId]);

    const columns = [
        {
            title: '商家ID',
            dataIndex: 'wmPoiId',
            key: 'wmPoiId',
            width: 80,
        },
        {
            title: '事件',
            dataIndex: 'eventType',
            key: 'eventType',
            width: 100,
        },
        {
            title: '状态变更',
            dataIndex: 'statusChange',
            key: 'statusChange',
            width: 180,
            render: (_, record) => {
                const { beforeStatus, afterStatus } = record;
                return `${beforeStatus || '无'} -> ${afterStatus || '无'}`;
            },
        },
        {
            title: '操作人类型',
            dataIndex: 'operatorType',
            key: 'operatorType',
            width: 80,
        },
        {
            title: '创建时间',
            dataIndex: 'ctime',
            key: 'ctime',
            width: 150,
            render: ctime => {
                if (!ctime || isNaN(ctime)) return '无效时间';
                return new Date(ctime * 1000).toLocaleString();
            },
        },
    ];

    return (
        <div style={{ padding: '20px', background: '#f5f6fa' }}>
            <TableNew
                rowKey="id"
                columns={columns}
                data={data}
                loading={loading}
                bordered
                scroll={{ x: '1000px', y: '50vh' }}
            />
        </div>
    );
};

export default DistributeRecord;
